var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.716675 33.0893H15.1332V35.1488H29.5497V20.595H23.3712V16.7259L32.7167 7.38043L28.3478 3.01154L23.3712 7.98812V2.0595H17.0156C16.5905 0.861009 15.4459 0 14.1034 0H9.98444C8.64198 0 7.49738 0.861009 7.0723 2.0595H0.716675V33.0893ZM27.4902 33.0893H17.1927V22.6545H19.2522V26.7735H25.4307V22.6545H27.4902V33.0893ZM21.3117 22.6545H23.3712V24.714H21.3117V22.6545ZM20.7085 16.476H19.2522V15.0197L25.4352 8.83671L26.8915 10.293L20.7085 16.476ZM29.8041 7.38043L28.3478 8.83671L26.8915 7.38043L28.3478 5.92416L29.8041 7.38043ZM8.95469 3.08925C8.95469 2.52145 9.41663 2.0595 9.98444 2.0595H14.1034C14.6712 2.0595 15.1332 2.52145 15.1332 3.08925V4.119H8.95469V3.08925ZM2.77618 4.119H6.89518V6.17851H17.1927V4.119H21.3117V10.0476L17.1927 14.1666V18.5355H21.3117V20.595H15.1332V31.0298H2.77618V4.119Z",
    fill: "#53AEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83569 8.23804H15.1332V10.2975H4.83569V8.23804Z",
    fill: "#53AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83569 12.357H15.1332V14.4165H4.83569V12.357Z",
    fill: "#53AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83569 16.476H15.1332V18.5355H4.83569V16.476Z",
    fill: "#53AEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3157 20.8967L7.92488 24.2875L6.59348 22.9562L5.13721 24.4124L7.92488 27.2001L12.772 22.3529L11.3157 20.8967Z",
    fill: "#53AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/Feature.26b6d98f91aebd6819ca35744b159e21.svg";
export { ForwardRef as ReactComponent };